import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "loading"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-ticket fa-fade" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_movie_grid_item = _resolveComponent("movie-grid-item")!
  const _component_slide = _resolveComponent("slide")!
  const _component_navigation = _resolveComponent("navigation")!
  const _component_carousel = _resolveComponent("carousel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.sectionTitle), 1),
    (_ctx.movies)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createVNode(_component_carousel, {
            settings: _ctx.carouselSettings,
            breakpoints: _ctx.carouselBreakpoints
          }, {
            addons: _withCtx(() => [
              _createVNode(_component_navigation)
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.movies, (movie) => {
                return (_openBlock(), _createBlock(_component_slide, {
                  key: movie.id
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_component_movie_grid_item, {
                      class: "carousel__item",
                      key: movie.id,
                      movie: movie,
                      onClick: ($event: any) => (_ctx.openModal(movie.id))
                    }, null, 8, ["movie", "onClick"]))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["settings", "breakpoints"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
  ], 64))
}